<section>
  <mat-card class="home-list">
    <mat-card-header>
      <mat-card-title class="pl-5"
        >Listado de solicitudes<button
          mat-icon-button
          class="float-right mr-5"
          data-toggle="collapse"
          data-target="#collapseSearch"
          aria-expanded="false"
          aria-controls="collapseSearch"
        >
          Filtrar<mat-icon>filter_alt</mat-icon>
        </button></mat-card-title
      >
    </mat-card-header>

    <!------------- Filtro ------------------>
    <mat-divider></mat-divider>
    <div class="collapse show" id="collapseSearch">
      <div [formGroup]="searchForm" style="padding: 16px">
        <div class="row mb-2 col-12">
          <div class="botones">
            <button
              mat-button
              class="aceptar"
              (click)="resetAll()"
              matTooltip="Presione para restablecer todos los filtros"
            >
              Restablecer filtros<mat-icon>restart_alt</mat-icon>
            </button>
          </div>
          <div class="botones">
            <button
              mat-button
              class="aceptar"
              (click)="listadoFirmasPendientes()"
              matTooltip="Presione para listado de procesos pendientes de firma"
            >
              Listado firmas pendientes <mat-icon>access_time</mat-icon>
            </button>
          </div>

          <div class="botones">
            <button
              mat-button
              class="aceptar"
              (click)="listadoFirmasOK()"
              matTooltip="Presione para listado de procesos de firma finalizados"
            >
              Listado firmas finalizadas <mat-icon>fingerprint</mat-icon>
            </button>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-2 col-md-6 col-sm-12">
            <label class="form-label">Num Pedido</label>
            <input
              type="text"
              class="form-control"
              formControlName="numPedido"
              (keyup)="applyFilter()"
            />
          </div>
          <div class="col-lg-2 col-md-6 col-sm-12">
            <label class="form-label">Expediente Ayuda</label>
            <input
              type="text"
              class="form-control"
              formControlName="expedienteAyudas"
              (keyup)="applyFilter()"
            />
          </div>

          <div class="col-lg-2 col-md-6 col-sm-12">
            <label class="form-label">Tipo</label>
            <select
              class="custom-select form-control"
              formControlName="tipo"
              (change)="applyFilter()"
            >
              <option value="">Todos</option>
              <option value="matriculacion">Matriculación</option>
              <option value="Cambio de propiedad">Cambio de propiedad</option>
              <option value="Notificacion venta">Notificación de venta</option>
              <option value="Distintivo ambiental">
                Distintivo medioambiental
              </option>
              <option value="Justificante profesional">
                Justificante profesional
              </option>
              <option value="informe">Informe</option>
              <option value="Reducción IVA 4%">Reducción IVA 4%</option>
              <option value="Bajas">Bajas</option>
              <option value="Custodia">Custodia</option>
              <option value="AYUDA MOVES">Moves</option>
              <option value="AYUDA REINICIA">Reinicia Auto</option>
              <option value="MATRICULACION INDUSTRIAL">Matriculación Industrial</option>
              <option value="MATRICULACION VEHICULO INDUSTRIAL">Matriculación Vehículo Industrial</option>
              <option value="MATRICULACION TURISMO">Matriculación Turismo</option>
              <option value="MATRICULACION VEHICULO ESPECIAL">Matriculación Vehículo Especial</option>
              <option value="MATRICULACION MOTOCICLETA">Matriculación Motocicleta</option>
              <option value="MATRICULACION CICLOMOTOR">Matriculación Ciclomotor</option>
              <option value="MATRICULACION VEHICULO IMPORTACION">Matriculación Vehículo Importación</option>
              <option value="CAMBIO DE PROPIEDAD INDUSTRIAL">Cambio de Propiedad Industrial</option>
              <option value="CAMBIO DE PROPIEDAD VEHICULO INDUSTRIAL">Cambio de Propiedad Vehículo Industrial</option>
              <option value="CAMBIO DE PROPIEDAD TURISMO">Cambio de Propiedad Turismo</option>
              <option value="CAMBIO DE PROPIEDAD VEHICULO ESPECIAL">Cambio de Propiedad Vehículo Especial</option>
              <option value="CAMBIO DE PROPIEDAD MOTOCICLETA">Cambio de Propiedad Motocicleta</option>
              <option value="CAMBIO DE PROPIEDAD CICLOMOTOR">Cambio de Propiedad Ciclomotor</option>
              <option value="NOTIFICACION VENTA INDUSTRIAL">Notificación de venta Industrial</option>
              <option value="Notificación de venta a particular">Notificación Venta Particular</option>
              <option value="NOTIFICACION VENTA TURISMO">Notificación Venta Turismo</option>
              <option value="NOTIFICACION VENTA ESPECIAL">Notificación Venta Especial</option>
              <option value="NOTIFICACION VENTA MOTOCICLETA">Notificación Venta Motocicleta</option>
              <option value="NOTIFICACION VENTA CICLOMOTOR">Notificación Venta Ciclomotor</option>
            </select>
          </div>

          <div class="col-lg-2 col-md-6 col-sm-12" *ngIf="role === 'GRUPO'">
            <label class="form-label">Colaborador</label>
            <select
              class="custom-select form-control"
              formControlName="colaborador"
              (change)="applyFilter()"
            >
              <option value="">Todos</option>
              <option
                *ngFor="let colaborador of colaboradores"
                [value]="colaborador"
              >
                {{ colaborador }}
              </option>
            </select>
          </div>

          <div class="col-lg-2 col-md-6 col-sm-12">
            <label class="form-label">Matricula</label>
            <input
              type="text"
              class="form-control"
              formControlName="matricula"
              (keyup)="applyFilter()"
              matTooltip="Comience a escribir un número de matricula para filtrar."
            />
          </div>

          <div class="col-lg-2 col-md-6 col-sm-12">
            <label class="form-label">Bastidor</label>
            <input
              type="text"
              class="form-control"
              formControlName="bastidor"
              (keyup)="applyFilter()"
              matTooltip="Comience a escribir un número de bastidor para filtrar."
            />
          </div>

          <div class="col-lg-2 col-md-6 col-sm-12">
            <label class="form-label">Nif</label>
            <input
              type="text"
              class="form-control"
              formControlName="nif"
              (keyup)="applyFilter()"
              matTooltip="Comience a escribir un Nif de cliente para filtrar."
            />
          </div>

          <mat-form-field
            class="col-lg-2 col-md-4 col-sm-12"
            appearance="standard"
          >
            <mat-label>Fecha</mat-label>
            <input
              matInput
              [matDatepicker]="picker1"
              formControlName="fecha"
              (dateChange)="applyFilter()"
              matTooltip="Seleccione una fecha para mostrar todos las solicitudes con fecha de entrada la fecha escogida."
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="picker1"
            ></mat-datepicker-toggle>
            <mat-datepicker #picker1></mat-datepicker>
          </mat-form-field>
        </div>
      </div>
      <mat-divider></mat-divider>
    </div>

    <mat-tab-group class="solicitudes-view-tabs">
      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon class="example-tab-icon">list</mat-icon>
          Listado
        </ng-template>
    <mat-card-content>
      <!-- Tabla principal --------- -------------------------->
      <mat-table
        [dataSource]="solicitudes"
        matSort
        (matSortChange)="print($event)"
        matSortActive="fecha"
        matSortDirection="desc"
      >
        <ng-container matColumnDef="numPedido">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            Num Pedido
          </mat-header-cell>
          <mat-cell *matCellDef="let element" data-label="numPedido">
            {{ element.numPedido }}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="expedienteAyudas">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            Expediente ayuda
          </mat-header-cell>
          <mat-cell *matCellDef="let element" data-label="expedienteAyudas">
            {{ element.expedienteAyudas }}
          </mat-cell>
        </ng-container>

        <!-- Tramite -->
        <ng-container matColumnDef="tipo">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            Tipo
          </mat-header-cell>
          <mat-cell *matCellDef="let element" data-label="trámite">
            {{ element.tipo }}
          </mat-cell>
        </ng-container>

        <!-- Tipo Tramite -->
        <ng-container matColumnDef="tipoTramite">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            Trámite
          </mat-header-cell>
          <mat-cell *matCellDef="let element" data-label="tipotrámite">
            {{ element.tipoTramite }}
          </mat-cell>
        </ng-container>

        <!-- Colaborador -->
        <ng-container matColumnDef="colaborador">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            Colaborador
          </mat-header-cell>
          <mat-cell *matCellDef="let element" data-label="colaborador">
            {{ element.colaborador }}
          </mat-cell>
        </ng-container>

        <!-- matricula -->
        <ng-container matColumnDef="matricula">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            Matricula
          </mat-header-cell>
          <mat-cell *matCellDef="let element" data-label="matricula">
            {{ element.matricula | null }}
          </mat-cell>
        </ng-container>

        <!-- bastidor -->
        <ng-container matColumnDef="bastidor">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            Bastidor
          </mat-header-cell>
          <mat-cell *matCellDef="let element" data-label="bastidor">
            {{ element.bastidor }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="generadoExpediente">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            Estado
          </mat-header-cell>
          <mat-cell
            *matCellDef="let element"
            data-label="estado"
            [ngSwitch]="deriveStatus(element)"
          >
            <a
              *ngSwitchCase="'EXPEDIENTE GENERADO'"
              (click)="goSolicitudes(element.generadoExpediente)"
              >EXPEDIENTE GENERADO</a
            >
            <span
              *ngSwitchDefault
              style="text-decoration: none; color: black"
              >{{ deriveStatus(element) }}</span
            >
          </mat-cell>
        </ng-container>

        <!-- NIF cliente -->
        <ng-container matColumnDef="nif">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            NIF cliente
          </mat-header-cell>
          <mat-cell *matCellDef="let element" data-label="NIF cliente">
            {{ element.nif }}
          </mat-cell>
        </ng-container>

        <!-- fecha entrada -->
        <ng-container matColumnDef="fecha">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            Fecha
          </mat-header-cell>
          <mat-cell *matCellDef="let element" data-label="F.recepcion">
            {{ element.fecha | date : "dd/MM/yyyy" }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="actions">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            Acciones
          </mat-header-cell>
          <mat-cell *matCellDef="let element" data-label="Acciones">
            <!--<button mat-icon-button >
              <mat-icon>info</mat-icon>
            </button>-->
            <button
              (click)="$event.stopPropagation()"
              mat-icon-button
              [matMenuTriggerFor]="menu"
              aria-label="Example icon-button with a menu"
            >
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #menu="matMenu">
              <button
                mat-menu-item
                (click)="reutilizar(element)"
                [disabled]="disabled"
                *ngIf="checkButton(element)"
              >
                <span>Reutilizar datos en un nuevo trámite</span>
              </button>
              <button
                mat-menu-item
                (click)="openDialog(element)"
                [disabled]="disabled"
              >
                <span>Adjuntar archivos</span>
              </button>
              <!--<button mat-menu-item  (click)="sendViafirma(element)"  [disabled]="!checkButtonViafirmaSend(element)">
                <span>Enviar firma de documentos</span>
              </button>-->
              <button
                mat-menu-item
                (click)="abrirModalComprobacionSigafirma(element)"
                [disabled]="disabled"
              >
                <span>Comprobar estado de firma</span>
              </button>
              <button
                mat-menu-item
                (click)="ampliarFirma(element)"
                [disabled]="disabled"
              >
                <span>Ampliar una semana plazo de firma</span>
              </button>
              <button
                mat-menu-item
                (click)="reenviarFirmaSet(element)"
                [disabled]="disabled"
              >
                <span>Reenviar notificación firma</span>
              </button>
              <button
                mat-menu-item
                (click)="reenviarFormularioMoves(element)"
                [disabled]="disabled"
                *ngIf="element.generadoExpediente == null && (element.completada==null || element.completada==0) && (element.tipo=='AYUDA MOVES' || element.tipo=='AYUDA REINICIA')"
              >
                <span>Reenviar formulario MOVES/Reinicia a cliente</span>
              </button>
              <!--<button mat-menu-item  (click)="cancelarFirma(element)" [disabled]="disabled"  >
                <span>Cancelar proceso de firma</span>
              </button>-->
              <button
                mat-menu-item
                (click)="enviar(element)"
                [disabled]="
                  disabled ||
                  element.email === null ||
                  !element.email.includes('@')
                "
              >
                <span>Enviar email a cliente para subida de archivos</span>
              </button>
              <button
                mat-menu-item
                (click)="openDialogUpdateSolicitud(element)"
                [disabled]="disabled"
                *ngIf="element.generadoExpediente == null"
              >
                <span>Editar pedido</span>
              </button>
              <button
                mat-menu-item
                (click)="cancelar(element)"
                [disabled]="disabled"
                *ngIf="element.generadoExpediente == null"
              >
                <span>Cancelar pedido</span>
              </button>
            </mat-menu>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="columns"></mat-header-row>
        <mat-row
          *matRowDef="let row; columns: columns; let i = index"
          matRipple
          class="element-row fila"
          [cdkDetailRow]="row"
          [cdkDetailRowTpl]="tpl"
          (click)="mostrar(row.id)"
        ></mat-row>

        <ng-template #tpl let-element>
          <div
            class="mat-row detail-row"
            [@detailExpand]
            style="overflow: hidden; display: none"
            id="{{ element.id }}"
          >
            <mat-tab-group>
              <!----------- SOLICITUD ---------->
              <mat-tab>
                <ng-template mat-tab-label>
                  <mat-icon class="example-tab-icon">assignment</mat-icon>
                  Solicitud
                </ng-template>
                <div class="container mb-4">
                  <div class="row" style="margin-left: 15px">
                    <div class="col-lg-3 col-md-3 col-sm-3 col-12 p-0 mr-3">
                      <label>Solicitud:</label>
                      <div class="borde m-0">
                        <p>
                          <b>{{ element.id }}</b>
                        </p>
                      </div>
                    </div>

                    <div class="col-lg-8 col-md-8 col-sm-8 col-12 p-0">
                      <label>Tipo</label>
                      <div class="borde m-0">
                        <p>
                          <b>{{ element.tipo }}</b>
                        </p>
                      </div>
                    </div>
                  </div>

                  <div class="row" style="margin-left: 15px">
                    <div class="col-lg-3 col-md-3 col-sm-3 p-0 col-12 mr-3">
                      <label>Nif Cliente</label>
                      <div class="borde m-0">
                        <p>
                          <b>{{ element.nif }}</b>
                        </p>
                      </div>
                    </div>
                    <div class="col-lg-8 col-md-8 col-sm-8 col-12 p-0">
                      <label>Nombre Cliente</label>
                      <div class="borde m-0">
                        <p>
                          <b
                            >{{ element.nombre | titlecase }}
                            {{ element.apellido1 | titlecase }}
                            {{ element.apellido2 | titlecase }}</b
                          >
                        </p>
                      </div>
                    </div>
                  </div>

                  <div class="row" style="margin-left: 15px">
                    <div class="col-lg-3 col-md-3 col-sm-3 p-0 col-12 mr-3">
                      <label>Nif Vendedor</label>
                      <div class="borde m-0">
                        <p>
                          <b>{{ element.nifVendedor | null }}</b>
                        </p>
                      </div>
                    </div>
                    <div class="col-lg-8 col-md-8 col-sm-8 col-12 p-0">
                      <label>Nombre Cliente Vendedor</label>
                      <div class="borde m-0">
                        <p>
                          <b
                            >{{ element.nombreVendedor | null | titlecase }}
                            {{ element.apellido1Vendedor | titlecase }}
                            {{ element.apellido2Vendedor | titlecase }}</b
                          >
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </mat-tab>
              <!------------CLIENTE------------->
              <mat-tab>
                <ng-template mat-tab-label>
                  <mat-icon class="example-tab-icon">assignment_ind</mat-icon>
                  Clientes
                </ng-template>
                <!-- DETALLES  Contenido cliente-->
                <div
                  class="container2 mb-4"
                  style="width: 90%; margin-top: 20px"
                >
                  <div class="row" style="margin-left: 15px">
                    <div
                      class="col-lg-2 col-md-2 col-sm-2 col-12 p-0 mr-3"
                      *ngIf="element.nif != null"
                    >
                      <label>Nif Comprador</label>
                      <div class="borde m-0">
                        <p>
                          <b>{{ element.nif }}</b>
                        </p>
                      </div>
                    </div>

                    <div
                      class="col-lg-3 col-md-8 col-sm-8 col-12 p-0 mr-3"
                      *ngIf="element.apellido1 != null"
                    >
                      <label>Nombre Comprador</label>
                      <div class="borde m-0">
                        <p>
                          <b
                            >{{ element.nombre | titlecase }}
                            {{ element.apellido1 | titlecase }}
                            {{ element.apellido2 | titlecase }}</b
                          >
                        </p>
                      </div>
                    </div>
                    <div
                      class="col-lg-4 col-md-8 col-sm-8 col-12 p-0"
                      *ngIf="
                        element.cp != null ||
                        element.poblacion != null ||
                        element.provincia != null
                      "
                    >
                      <label>Poblacion/CP</label>
                      <div class="borde m-0">
                        <p>
                          <b
                            >{{ element.cp }},
                            {{ element.poblacion | titlecase }},
                            {{ element.provincia | titlecase }}
                          </b>
                        </p>
                      </div>
                    </div>
                    <div
                      class="col-lg-3 col-md-4 col-sm-4 col-12 p-0 mr-3"
                      *ngIf="element.email != null"
                    >
                      <label>Email </label><br />
                      <div class="borde m-0" style="display: inline-block">
                        <p>
                          <b>{{ element.email }}</b>
                        </p>
                      </div>
                      <!--
                      <button mat-icon-button style="display: inline-block" (click)="enviar(element, cliente)"  matTooltip="Enviar email a cliente para subida de archivos" *ngIf="cliente && cliente.emailCliente != null && cliente.emailCliente.includes('@')">
                        <mat-icon>send</mat-icon>
                      </button>-->
                    </div>

                    <div
                      class="col-lg-3 col-md-3 col-sm-3 col-12 p-0 mr-3"
                      *ngIf="element.telefono != null"
                    >
                      <label>Teléfono </label><br />
                      <div class="borde m-0" style="display: inline-block">
                        <p>
                          <b>{{ element.telefono }}</b>
                        </p>
                      </div>
                      <!--
                      <button mat-icon-button style="display: inline-block" (click)="enviarSMS(expComprador,element)" matTooltip="Enviar sms al cliente par firma digital de documentos" *ngIf="checkDataComprador(cliente)">
                        <mat-icon>sms</mat-icon>
                      </button>
                      -->
                    </div>

                    <div
                      class="col-lg-9 col-md-9 col-sm-12 col-12 p-0 mr-3"
                      *ngIf="element.direccion != null"
                    >
                      <label>Direccion Comprador</label>
                      <div class="borde m-0">
                        <p>
                          <b
                            >{{ element.direccion | titlecase }}
                            {{ element.direccionnumero | titlecase }},
                            {{ element.direccionEscalera | titlecase }}
                            {{ element.direccionpiso | titlecase }}
                            {{ element.direccionpuerta | titlecase }}
                          </b>
                        </p>
                      </div>
                    </div>
                  </div>
                  <hr />
                  <div class="row" style="margin-left: 15px">
                    <div
                      class="col-lg-2 col-md-2 col-sm-2 col-12 p-0 mr-3"
                      *ngIf="element.nifVendedor != null"
                    >
                      <label>Nif Vendedor</label>
                      <div class="borde m-0">
                        <p>
                          <b>{{ element.nifVendedor }}</b>
                        </p>
                      </div>
                    </div>

                    <div
                      class="col-lg-3 col-md-8 col-sm-8 col-12 p-0 mr-3"
                      *ngIf="
                        element.nombreVendedor != null ||
                        element.apellido1Vendedor != null ||
                        element.apellido2Vendedor != null
                      "
                    >
                      <label>Nombre Vendedor</label>
                      <div class="borde m-0">
                        <p>
                          <b
                            >{{ element.nombreVendedor | titlecase }}
                            {{ element.apellido1Vendedor | titlecase }}
                            {{ element.apellido2Vendedor | titlecase }}</b
                          >
                        </p>
                      </div>
                    </div>
                    <div
                      class="col-lg-4 col-md-8 col-sm-8 col-12 p-0"
                      *ngIf="
                        element.cpVendedor != null ||
                        element.poblacionVendedor != null ||
                        element.provinciaVendedor != null
                      "
                    >
                      <label>Poblacion/CP</label>
                      <div class="borde m-0">
                        <p>
                          <b
                            >{{ element.cpVendedor }},
                            {{ element.poblacionVendedor | titlecase }},
                            {{ element.provinciaVendedor | titlecase }}
                          </b>
                        </p>
                      </div>
                    </div>
                    <div
                      class="col-lg-3 col-md-4 col-sm-4 col-12 p-0 mr-3"
                      *ngIf="element.emailVendedor != null"
                    >
                      <label>Email </label><br />
                      <div class="borde m-0" style="display: inline-block">
                        <p>
                          <b>{{ element.emailVendedor }}</b>
                        </p>
                      </div>
                      <!--
                      <button mat-icon-button style="display: inline-block" (click)="enviar(element, clienteVendedor)"  matTooltip="Enviar email a cliente para subida de archivos" *ngIf="clienteVendedor && clienteVendedor.emailCliente != null && clienteVendedor.emailCliente.includes('@')">
                        <mat-icon>send</mat-icon>
                      </button>
                      -->
                    </div>

                    <div
                      class="col-lg-3 col-md-3 col-sm-3 col-12 p-0 mr-3"
                      *ngIf="element.telefonoVendedor != null"
                    >
                      <label>Teléfono </label><br />
                      <div class="borde m-0" style="display: inline-block">
                        <p>
                          <b>{{ element.telefonoVendedor }}</b>
                        </p>
                      </div>
                      <!--
                      <button mat-icon-button style="display: inline-block" (click)="enviarSMS(expVendedor, element)"  matTooltip="Enviar sms al cliente par firma digital de documentos" *ngIf="checkDataVendedor(clienteVendedor)">
                        <mat-icon>sms</mat-icon>
                      </button>
                      -->
                    </div>

                    <div
                      class="col-lg-9 col-md-9 col-sm-12 col-12 p-0 mr-3"
                      *ngIf="element.direccionVendedor != null"
                    >
                      <label>Direccion Vendedor</label>
                      <div class="borde m-0">
                        <p>
                          <b
                            >{{ element.direccionVendedor | titlecase }}
                            {{ element.direccionnumeroVendedor | titlecase }},
                            {{ element.direccionpisoVendedor | titlecase }}
                            {{ element.direccionpuertaVendedor | titlecase }}
                          </b>
                        </p>
                      </div>
                    </div>
                  </div>
                  <hr />
                </div>
              </mat-tab>
              <!------------VEHICULO------------->
              <mat-tab>
                <ng-template mat-tab-label>
                  <mat-icon class="example-tab-icon"
                    >directions_car_filled</mat-icon
                  >
                  Vehículo
                </ng-template>
                <!-- DETALLES  Vehiculo   ---------------------------------------->
                <div class="contenedor3 mb-4">
                  <div class="row" style="margin-left: 15px">
                    <div
                      class="col-lg-3 col-md-3 col-sm-3 p-0 pr-3"
                      *ngIf="element.matricula != null"
                    >
                      <label>Matricula</label>
                      <div class="borde m-0">
                        <p>
                          <b>{{ element.matricula | null }}</b>
                        </p>
                      </div>
                    </div>
                    <div
                      class="col-lg-3 col-md-3 col-sm-3 p-0 pr-3"
                      *ngIf="element.fechaMatriculacion != null"
                    >
                      <label>F.Matriculación</label>
                      <div class="borde m-0">
                        <p *ngIf="element.fechaMatriculacion">
                          <b>{{
                            element.fechaMatriculacion
                              | null
                              | date : "dd/MM/yyyy"
                          }}</b>
                        </p>
                        <p *ngIf="!element.fechaMatriculacion"><b> - </b></p>
                      </div>
                    </div>
                    <div
                      class="col-lg-6 col-md-6 col-sm-6 p-0 pr-3"
                      *ngIf="element.bastidor != null"
                    >
                      <label>Bastidor</label>
                      <div class="borde m-0">
                        <p>
                          <b>{{ element.bastidor | null }}</b>
                        </p>
                      </div>
                    </div>

                    <div
                      class="col-lg-6 col-md-6 col-sm-6 p-0"
                      *ngIf="element.tipoVehiculo != null"
                    >
                      <label>Tipo</label>
                      <div class="borde m-0">
                        <p>
                          <b>{{ element.tipoVehiculo | null }}</b>
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="row" style="margin-left: 15px">
                    <div
                      class="col-lg-2 col-md-4 col-sm-4 p-0 pr-3"
                      *ngIf="element.marca != null"
                    >
                      <label>Marca</label>
                      <div class="borde m-0">
                        <p>
                          <b>{{ element.marca | null }}</b>
                        </p>
                      </div>
                    </div>
                    <div
                      class="col-lg-3 col-md-8 col-sm-8 p-0 pr-3"
                      *ngIf="element.modelo != null"
                    >
                      <label>Modelo</label>
                      <div class="borde m-0">
                        <p>
                          <b>{{ element.modelo | null }}</b>
                        </p>
                      </div>
                    </div>
                    <div
                      class="col-lg-2 col-md-2 col-sm-2 p-0"
                      *ngIf="element.cilindrada != null"
                    >
                      <label>Cilindrada</label>
                      <div class="borde m-0">
                        <p>
                          <b>{{ element.cilindrada | null }}</b>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </mat-tab>
              <!------------AYUDA------------->
              <mat-tab>
                <ng-template mat-tab-label>
                  <mat-icon class="example-tab-icon">electrical_services</mat-icon>
                  Ayudas
                </ng-template>
                <!-- DETALLES  Contenido ayuda-->
                <div
                  class="container2 mb-4"
                  style="width: 90%; margin-top: 20px"
                >
                  <div class="row" style="margin-left: 15px">
                    <div
                      class="col-lg-2 col-md-5 col-sm-2 col-12 p-0 mr-3"
                      *ngIf="element.tipoAyuda != null && element.tipoAyuda != ''"
                    >
                      <label>Tipo de ayuda</label>
                      <div class="borde m-0">
                        <p>
                          <b>{{ element.tipoAyuda }}</b>
                        </p>
                      </div>
                    </div>
                    <div
                      class="col-lg-2 col-md-5 col-sm-2 col-12 p-0 mr-3"
                      *ngIf="element.facturarA != null && element.facturarA != ''"
                    >
                      <label>Facturar a</label>
                      <div class="borde m-0">
                        <p>
                          <b>{{ element.facturarA }}</b>
                        </p>
                      </div>
                    </div>
                    <div
                      class="col-lg-2 col-md-5 col-sm-2 col-12 p-0 mr-3"
                      *ngIf="element.tipoSolicitante != null && element.tipoSolicitante != ''"
                    >
                      <label>Tipo de solicitante</label>
                      <div class="borde m-0">
                        <p>
                          <b>{{ element.tipoSolicitante }}</b>
                        </p>
                      </div>
                    </div>
                    <div
                      class="col-lg-2 col-md-5 col-sm-2 col-12 p-0 mr-3"
                      *ngIf="element.tipoAdquisicion != null && element.tipoAdquisicion != ''"
                    >
                      <label>Tipo de adquisición</label>
                      <div class="borde m-0">
                        <p>
                          <b>{{ element.tipoAdquisicion }}</b>
                        </p>
                      </div>
                    </div>
                    </div>
                    <div class="row" style="margin-left: 15px">
                    <div
                    class="col-lg-2 col-md-5 col-sm-2 col-12 p-0 mr-3"
                    *ngIf="element.ayudaAdicional != null && element.ayudaAdicional != ''"
                    >
                    <label>Ayuda adicional</label>
                    <div class="borde m-0">
                      <p>
                        <b>{{ element.ayudaAdicional }}</b>
                      </p>
                    </div>
                  </div>
                    <div
                      class="col-lg-3 col-md-8 col-sm-8 col-12 p-0 mr-3"
                      *ngIf="element.matriculaAchatarrado != null && element.matriculaAchatarrado != ''"
                    >
                      <label>Vehículo achatarrado</label>
                      <div class="borde m-0">
                        <p>
                          <b
                            >{{ element.matriculaAchatarrado | titlecase }}
                            {{ element.marcaAchatarrado | titlecase }}
                            {{ element.modeloAchatarrado | titlecase }}</b
                          >
                        </p>
                      </div>
                    </div>
                    <div
                      class="col-lg-4 col-md-8 col-sm-8 col-12 p-0"
                      *ngIf="
                        element.iban != null && element.iban != ''"
                    >
                      <label>IBAN</label>
                      <div class="borde m-0">
                        <p>
                          <b
                            >{{ element.iban }}
                          </b>
                        </p>
                      </div>
                    </div>
                    </div>
                    <div class="row" style="margin-left: 15px">
                      <div
                        class="col-lg-2 col-md-4 col-sm-3 col-12 p-0 mr-3"
                        *ngIf="element.demo == true; else nodemo"
                      >
                        <label>Es vehículo demo </label><br />
                        <div class="borde m-0" style="display: inline-block">
                          <p>
                            <b>Sí</b>
                          </p>
                        </div>
                      </div>

                      <ng-template #nodemo>
                        <div
                        class="col-lg-2 col-md-4 col-sm-3 col-12 p-0 mr-3"
                      >
                        <label>Es vehículo demo </label><br />
                        <div class="borde m-0" style="display: inline-block">
                          <p>
                            <b>No</b>
                          </p>
                        </div>
                      </div>
                      </ng-template>
                      <div
                        class="col-lg-2 col-md-4 col-sm-3 col-12 p-0 mr-3"
                        *ngIf="element.vehiculoNuevo == true; else usado"
                      >
                        <label>Es vehículo nuevo </label><br />
                        <div class="borde m-0" style="display: inline-block">
                          <p>
                            <b>Sí</b>
                          </p>
                        </div>
                      </div>

                      <ng-template #usado>
                        <div
                        class="col-lg-2 col-md-4 col-sm-3 col-12 p-0 mr-3"
                      >
                        <label>Es vehículo nuevo </label><br />
                        <div class="borde m-0" style="display: inline-block">
                          <p>
                            <b>No</b>
                          </p>
                        </div>
                      </div>
                      </ng-template>
                      <div
                        class="col-lg-4 col-md-4 col-sm-4 col-12 p-0 mr-3"
                        *ngIf="element.marcaModeloElectrico != null && element.marcaModeloElectrico != ''"
                      >
                        <label>Vehículo eléctrico </label><br />
                        <div class="borde m-0" style="display: inline-block">
                          <p>
                            <b>{{ element.marcaModeloElectrico }}</b>
                          </p>
                        </div>
                      </div>
                      <div
                        class="col-lg-2 col-md-4 col-sm-4 col-12 p-0 mr-3"
                        *ngIf="element.potenciaElectrico != null && element.potenciaElectrico != ''"
                      >
                        <label>Potencia Kwh</label><br />
                        <div class="borde m-0" style="display: inline-block">
                          <p>
                            <b>{{ element.potenciaElectrico }}</b>
                          </p>
                        </div>
                      </div>
                      <div
                        class="col-lg-2 col-md-4 col-sm-4 col-12 p-0 mr-3"
                        *ngIf="element.autonomiaElectrico != null && element.autonomiaElectrico != ''"
                      >
                        <label>Autonomía Km</label><br />
                        <div class="borde m-0" style="display: inline-block">
                          <p>
                            <b>{{ element.autonomiaElectrico }}</b>
                          </p>
                        </div>
                      </div>
                      <div
                        class="col-lg-1 col-md-4 col-sm-3 col-12 p-0 mr-3"
                        *ngIf="element.importeMinimis != null && element.importeMinimis != ''"
                      >
                        <label>Importe Minimis </label><br />
                        <div class="borde m-0" style="display: inline-block">
                          <p>
                            <b>{{ element.importeMinimis }}</b>
                          </p>
                        </div>
                      </div>
                    </div>
                    
                    
                  <hr />
                </div>
              </mat-tab>
              <!-----------DOCUMENTOS------------->
              <mat-tab>
                <ng-template mat-tab-label>
                  <mat-icon class="example-tab-icon">description</mat-icon>
                  Documentos
                </ng-template>
                <!-- DETALLES  Contenido cliente-->
                <div
                  class="container2 mb-4"
                  style="width: 90%; margin-top: 20px"
                >
                  <div class="row" style="margin-left: 15px">
                    <div
                      class="col-lg-3 col-md-3 col-sm-12 cajaIcono"
                      *ngFor="let doc of docList"
                    >
                      <div class="row">
                        <div class="col-lg-8 col-md-8 col-sm-8 cajaName">
                          <div class="borde m-0 text-center">
                            <p>
                              <b>{{ doc.typeSettings.docType.name }}</b>
                            </p>
                          </div>
                        </div>
                        <div
                          class="col-lg-4 col-md-4 col-sm-4 cajaIcono"
                          (click)="verArchivo(doc)"
                        >
                          <div class="espacio">
                            <img src="assets/icons/download.png" width="35" />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-3 col-md-3 col-sm-12 cajaIcono">
                      <div class="row">
                        <div class="col-lg-8 col-md-8 col-sm-8 cajaName">
                          <div class="borde m-0 text-center">
                            <p><b>Documentos de firma</b></p>
                          </div>
                        </div>
                        <div
                          class="col-lg-4 col-md-4 col-sm-4 cajaIcono"
                          (click)="abrirModalComprobacionSigafirma(element)"
                        >
                          <div class="espacio">
                            <img src="assets/icons/download.png" width="35" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </mat-tab>
              <!------------OBSERVACIONES------------->
              <mat-tab>
                <ng-template mat-tab-label>
                  <mat-icon class="example-tab-icon">edit_note</mat-icon>
                  Observaciones
                </ng-template>
                <!-- DETALLES  Contenido ayuda-->
                <div
                  class="container2 mb-4"
                  style="width: 90%; margin-top: 20px"
                >
                  <div class="row" style="margin-left: 15px">
                    <div
                      class="col-lg-2 col-md-5 col-sm-2 col-12 p-0 mr-3"
                    >
                      <label>Observaciones</label>
                      <div class="borde m-0">
                        <p><textarea rows="6" cols="30" disabled>{{ element.observaciones }}</textarea></p>
                      </div>
                    </div>
                  </div>
                    
                    
                  <hr />
                </div>
              </mat-tab>
            </mat-tab-group>
          </div>
        </ng-template>
      </mat-table>
    </mat-card-content>
      </mat-tab>

      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon class="example-tab-icon">space_dashboard</mat-icon>
          Panel
        </ng-template>
        <div class="kanban-board">
          <div class="kanban-column" *ngFor="let column of groupedSolicitudes">
            <div class="kanban-column-header" [style.borderTopColor]="column.color">
              <mat-icon [style.color]="column.color">{{ column.icon }}</mat-icon>
              <span class="kanban-column-title">{{ column.label }}</span>
              <span class="kanban-column-count">{{ column.items.length }}</span>
            </div>
            <div class="kanban-column-body">
              <div class="kanban-card" *ngFor="let item of column.items"
                   [matTooltip]="getCardTooltip(item)"
                   matTooltipPosition="right"
                   matTooltipClass="kanban-tooltip">
                <div class="kanban-card-header" (click)="toggleCard(item.id)">
                  <div class="kanban-card-header-left">
                    <mat-icon class="kanban-toggle-icon">{{ isCardExpanded(item.id) ? 'expand_more' : 'chevron_right' }}</mat-icon>
                    <div class="kanban-card-header-text">
                      <span class="kanban-card-tipo">{{ item.tipo }}</span>
                      <span class="kanban-card-pedido">{{ item.matricula || item.bastidor || item.nif || item.id }}</span>
                    </div>
                  </div>
                  <button mat-icon-button
                          [matMenuTriggerFor]="kanbanMenu"
                          [matMenuTriggerData]="{item: item}"
                          (click)="$event.stopPropagation()"
                          class="kanban-card-actions">
                    <mat-icon>more_vert</mat-icon>
                  </button>
                </div>
                <div class="kanban-card-body" *ngIf="isCardExpanded(item.id)">
                  <div class="kanban-card-field">
                    <span class="kanban-field-label">ID</span>
                    <span class="kanban-field-value">{{ item.id }}</span>
                  </div>
                  <div class="kanban-card-field">
                    <span class="kanban-field-label">Num.Pedido</span>
                    <span class="kanban-field-value">{{ item.numPedido }}</span>
                  </div>
                  <div class="kanban-card-field">
                    <span class="kanban-field-label">Tipo</span>
                    <span class="kanban-field-value">{{ item.tipo }}</span>
                  </div>
                  <div class="kanban-card-field">
                    <span class="kanban-field-label">Matrícula</span>
                    <span class="kanban-field-value">{{ item.matricula | null }}</span>
                  </div>
                  <div class="kanban-card-field">
                    <span class="kanban-field-label">NIF</span>
                    <span class="kanban-field-value">{{ item.nif }}</span>
                  </div>
                  <div class="kanban-card-field">
                    <span class="kanban-field-label">Fecha</span>
                    <span class="kanban-field-value">{{ item.fecha | date:'dd/MM/yyyy' }}</span>
                  </div>
                  <div class="kanban-card-observaciones" *ngIf="item.observaciones">
                    <span class="kanban-field-label">Observaciones</span>
                    <p class="kanban-observaciones-text">{{ item.observaciones }}</p>
                  </div>
                </div>
                <div class="kanban-card-footer" *ngIf="isCardExpanded(item.id) && item.generadoExpediente != false && item.generadoExpediente !== '0' && item.generadoExpediente != null">
                  <a class="kanban-expediente-link" (click)="goSolicitudes(item.generadoExpediente)">
                    Exp: {{ item.generadoExpediente }}
                  </a>
                </div>
              </div>
              <div class="kanban-empty" *ngIf="column.items.length === 0">
                <mat-icon>inbox</mat-icon>
                <span>Sin solicitudes</span>
              </div>
            </div>
          </div>
        </div>
        <mat-menu #kanbanMenu="matMenu">
          <ng-template matMenuContent let-item="item">
            <button mat-menu-item (click)="reutilizar(item)"
                    [disabled]="disabled" *ngIf="checkButton(item)">
              <span>Reutilizar datos en un nuevo trámite</span>
            </button>
            <button mat-menu-item (click)="openDialog(item)"
                    [disabled]="disabled">
              <span>Adjuntar archivos</span>
            </button>
            <button mat-menu-item (click)="abrirModalComprobacionSigafirma(item)"
                    [disabled]="disabled">
              <span>Comprobar estado de firma</span>
            </button>
            <button mat-menu-item (click)="ampliarFirma(item)"
                    [disabled]="disabled">
              <span>Ampliar una semana plazo de firma</span>
            </button>
            <button mat-menu-item (click)="reenviarFirmaSet(item)"
                    [disabled]="disabled">
              <span>Reenviar notificación firma</span>
            </button>
            <button mat-menu-item (click)="reenviarFormularioMoves(item)"
                    [disabled]="disabled"
                    *ngIf="item.generadoExpediente == null && (item.completada==null || item.completada==0) && (item.tipo=='AYUDA MOVES' || item.tipo=='AYUDA REINICIA')">
              <span>Reenviar formulario MOVES/Reinicia a cliente</span>
            </button>
            <button mat-menu-item (click)="enviar(item)"
                    [disabled]="disabled || item.email === null || !item.email?.includes('@')">
              <span>Enviar email a cliente para subida de archivos</span>
            </button>
            <button mat-menu-item (click)="openDialogUpdateSolicitud(item)"
                    [disabled]="disabled"
                    *ngIf="item.generadoExpediente == null">
              <span>Editar pedido</span>
            </button>
            <button mat-menu-item (click)="cancelar(item)"
                    [disabled]="disabled"
                    *ngIf="item.generadoExpediente == null">
              <span>Cancelar pedido</span>
            </button>
          </ng-template>
        </mat-menu>
      </mat-tab>
    </mat-tab-group>
    <mat-paginator
      #MatPaginator
      [pageIndex]="pageIndex"
      [pageSize]="pageSize"
      [length]="lenghtPagination"
      showFirstLastButtons
      (page)="getServerData($event)"
    ></mat-paginator>
  </mat-card>
</section>

<div
  *ngIf="spinner"
  class="spinner swal2-container swal2-center swal2-backdrop-show"
>
  <img class="spinner-img" alt="" src="../../../assets/img/logo-empresa.png" />
</div>
